import { Link } from 'react-router-dom';

export default function PrivacyPolicy() {
    return (
        <div className="min-h-screen bg-white">
            <div className="max-w-3xl mx-auto px-6 py-16">
                <div className="mb-8">
                    <Link to="/" className="text-sm text-blue-600 hover:text-blue-700">
                        ← Back to CourseMap
                    </Link>
                </div>

                <h1 className="text-3xl font-bold text-gray-900 mb-2">Privacy Policy</h1>
                <p className="text-sm text-gray-400 mb-10">Last updated: Mar 28, 2026</p>

                <div className="prose prose-gray max-w-none space-y-8 text-gray-700 leading-relaxed">
                    <p>
                        CourseMap ("we", "our", or "us") respects your privacy. This Privacy Policy explains how we collect,
                        use, and protect your information when you use our website.
                    </p>

                    <section>
                        <h2 className="text-lg font-semibold text-gray-900 mb-3">1. Information We Collect</h2>
                        <p className="mb-2">When you use CourseMap, we may collect the following information:</p>
                        <ul className="list-disc pl-5 space-y-1">
                            <li><strong>Personal Information:</strong> Your name and email address, provided through Google Sign-In.</li>
                            <li><strong>Academic Information:</strong> Information you voluntarily provide, such as your school, major, courses taken, and exams.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-lg font-semibold text-gray-900 mb-3">2. How We Collect Information</h2>
                        <p className="mb-2">We collect information when you:</p>
                        <ul className="list-disc pl-5 space-y-1">
                            <li>Sign in using your Google account</li>
                            <li>Enter your academic information into the platform</li>
                        </ul>
                        <p className="mt-2">Google Sign-In is subject to Google's Privacy Policy.</p>
                    </section>

                    <section>
                        <h2 className="text-lg font-semibold text-gray-900 mb-3">3. How We Use Your Information</h2>
                        <p className="mb-2">We use your information to:</p>
                        <ul className="list-disc pl-5 space-y-1">
                            <li>Provide course planning and recommendation features</li>
                            <li>Improve and maintain our services</li>
                            <li>Communicate with you regarding your account or important updates</li>
                        </ul>
                        <p className="mt-2">We may send service-related emails. We will not send marketing emails without your consent.</p>
                    </section>

                    <section>
                        <h2 className="text-lg font-semibold text-gray-900 mb-3">4. Data Sharing</h2>
                        <p className="mb-2">We do not sell, trade, or share your personal data with third parties.</p>
                        <p>We may use trusted service providers (such as hosting or authentication services) strictly to operate our website.</p>
                    </section>

                    <section>
                        <h2 className="text-lg font-semibold text-gray-900 mb-3">5. Cookies</h2>
                        <p>We do not use cookies for tracking or advertising purposes. We may use essential technologies required for authentication and basic functionality.</p>
                    </section>

                    <section>
                        <h2 className="text-lg font-semibold text-gray-900 mb-3">6. Data Security</h2>
                        <p>We implement reasonable security measures to protect your data. However, no system is completely secure.</p>
                    </section>

                    <section>
                        <h2 className="text-lg font-semibold text-gray-900 mb-3">7. Your Rights</h2>
                        <p>You may request access to or deletion of your personal data by contacting us.</p>
                    </section>

                    <section>
                        <h2 className="text-lg font-semibold text-gray-900 mb-3">8. Changes to This Policy</h2>
                        <p>We may update this Privacy Policy from time to time. Continued use of the service constitutes acceptance of the updated policy.</p>
                    </section>

                    <section>
                        <h2 className="text-lg font-semibold text-gray-900 mb-3">9. Contact</h2>
                        <p>If you have any questions, please contact us at: <a href="mailto:admin@coursemap.app" className="text-blue-600 hover:underline">admin@coursemap.app</a></p>
                    </section>
                </div>
            </div>
        </div>
    );
}
